import styled from 'styled-components';

export const Content = styled.div`
  .reasons-title {
    font-size: 14px;
    color: ${(props) => props.theme.$dark};
  }

  .reason-cell {
    width: 100%;
    max-width: 0;
    min-width: 0;

    > span {
      display: -webkit-box;
      -webkit-line-clamp: 2;
      -webkit-box-orient: vertical;
      overflow: hidden;
    }
  }

  .reasons-footer {
    font-size: 13px;
  }
`;
